import React from 'react';

let Icons = (props) => {

  switch(props.name) {
    case "calendar":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.36 61.48">
          <g data-name="i_calendar">
            <g data-name="Layer 1">
              <path d="M34.38 42.33l.12-.16q.31-.4.64-.78a13.5 13.5 0 0 1 5.36-3.65l.18-.07c.28-.1.56-.18.84-.26l.39-.1.72-.16.63-.1.56-.07c.41 0 .83-.06 1.25-.06h.97a13.39 13.39 0 0 1 3.78.85 1 1 0 0 0 1.4-1V3.07a1 1 0 0 0-1-1h-3.08V1a1 1 0 1 0-2 0v1H43V1a1 1 0 1 0-2 0v1h-2V1a1 1 0 1 0-2 0v1h-2V1a1 1 0 0 0-2 0v1H18.45V1a1 1 0 0 0-2 0v1h-2V1a1 1 0 0 0-2 0v1h-2V1a1 1 0 0 0-2 0v1h-2V1a1 1 0 0 0-2 0v1H1a1 1 0 0 0-1 1v48.24a1 1 0 0 0 1 1h29.79a1 1 0 0 0 1-1V51v-.83a13.27 13.27 0 0 1 .36-3 13.09 13.09 0 0 1 1-2.84l.13-.27c.14-.26.28-.51.44-.76l.15-.24q.23-.36.51-.73zm2.51-12.61h-6.15v-6.15h6.15zm0-8.2h-6.15v-6.15h6.15zm8.2 2v6.15h-6.15v-6.1zm-6.15-2v-6.15h6.15v6.15zm6.15 13.32c-.48 0-1 0-1.42.07l-.6.08-.75.11-.77.16-.47.12-.92.28h-.12c-.37.13-.74.27-1.1.42v-4.31h6.15zM2 4.1h2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h14.79v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v5.12H2zm27.72 46.11H2V11.27h47.19v24.14a15.23 15.23 0 0 0-2-.43V14.35a1 1 0 0 0-1-1h-41a1 1 0 0 0-1 1v32.79a1 1 0 0 0 1 1h24.68a15.36 15.36 0 0 0-.15 2.07zm-7.17-12.3v-6.14h6.15v6.15zm6.15 2v6.15h-6.16V40zm-6.16-10.19v-6.15h6.15v6.15zm0-8.2v-6.15h6.15v6.15zm-8.2 16.4v-6.15h6.15v6.15zm6.15 2v6.15h-6.14V40zm-6.14-10.2v-6.15h6.15v6.15zm0-8.2v-6.15h6.15v6.15zm-8.2 16.4v-6.15h6.15v6.15zm6.15 2v6.15H6.15V40zm-6.15-10.2v-6.15h6.15v6.15zm0-8.2v-6.15h6.15v6.15zm25.67 21l-.11.17c-.15.26-.28.53-.41.8s-.15.29-.21.44-.22.5-.31.75v.07V40h2.92a15.47 15.47 0 0 0-1.88 2.49zm-1.08-4.57v-6.18h6.15v5.47c-.35.22-.69.46-1 .71z"/>
              <path d="M45.09 38.94a11.27 11.27 0 1 0 11.27 11.27 11.27 11.27 0 0 0-11.27-11.27zm0 20.49a9.22 9.22 0 1 1 9.22-9.22 9.22 9.22 0 0 1-9.22 9.22z"/>
              <path d="M49.49 44.36l-4.4 4.4-2.35-2.35a1 1 0 0 0-1.45 1.45l3.07 3.07a1 1 0 0 0 1.45 0l5.12-5.12a1 1 0 0 0-1.45-1.45z"/>
            </g>
          </g>
        </svg>
      )
    case "addNew":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.43 58.38">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M29.24 0a29.19 29.19 0 1 0 29.19 29.19A29.25 29.25 0 0 0 29.24 0zm0 54.3a25.11 25.11 0 1 1 25.11-25.11A25.15 25.15 0 0 1 29.24 54.3zm0 0"/>
              <path d="M42.68 26.87H31.3V15.45a2.06 2.06 0 0 0-4.13 0v11.37H15.8a2.06 2.06 0 1 0 0 4.13h11.38v11.38a2.06 2.06 0 0 0 4.13 0V31h11.37a2 2 0 0 0 2.06-2.06 2 2 0 0 0-2.06-2zm0 0"/>
            </g>
          </g>
        </svg>
      )
    case "arrowThin":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.33 56.38">
          <g data-name="Layer 2">
            <path fill="none" strokeLinecap="round" strokeMiterlimit="10" d="M.5.5l28.13 28.13L1.38 55.88" data-name="Layer 1"/>
          </g>
        </svg>
      )
    case "admin":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.43 58.43">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M29.22 14.07a15.15 15.15 0 1 0 15.14 15.15 15.17 15.17 0 0 0-15.14-15.15zm0 28.13a13 13 0 1 1 13-13 13 13 0 0 1-13 13z"/>
              <path d="M55.42 22.72h-2.18a24.81 24.81 0 0 0-2.45-5.91l1.54-1.54a3 3 0 0 0 0-4.25l-4.92-4.93a3.08 3.08 0 0 0-4.25 0l-1.55 1.55a24.65 24.65 0 0 0-5.91-2.45V3a3 3 0 0 0-3-3h-7a3 3 0 0 0-3 3v2.19a24.66 24.66 0 0 0-5.91 2.44l-1.52-1.54a3.08 3.08 0 0 0-4.25 0L6.09 11a3 3 0 0 0 0 4.25l1.54 1.54a24.52 24.52 0 0 0-2.44 5.91H3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h2.19a24.61 24.61 0 0 0 2.44 5.91l-1.54 1.54a3 3 0 0 0 0 4.26L11 52.34a3.08 3.08 0 0 0 4.25 0l1.54-1.54a25 25 0 0 0 5.91 2.45v2.18a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-2.19a24.89 24.89 0 0 0 5.91-2.45l1.54 1.54a3.09 3.09 0 0 0 4.26 0l4.92-4.92a3 3 0 0 0 0-4.26l-1.53-1.54a24.9 24.9 0 0 0 2.45-5.91h2.18a3 3 0 0 0 3-3v-7a3 3 0 0 0-3.01-2.98zm.85 10a.85.85 0 0 1-.85.85h-3.89l-.2.83a22.49 22.49 0 0 1-2.83 6.83l-.45.73 2.75 2.75a.84.84 0 0 1 0 1.19l-4.92 4.92a.84.84 0 0 1-1.19 0l-2.75-2.75-.73.45a22.5 22.5 0 0 1-6.83 2.83l-.83.2v3.89a.85.85 0 0 1-.85.85h-7a.85.85 0 0 1-.85-.85v-3.91l-.83-.2a22.41 22.41 0 0 1-6.83-2.83l-.73-.45-2.75 2.75a.85.85 0 0 1-1.2 0l-4.89-4.92a.85.85 0 0 1 0-1.19l2.75-2.75-.45-.73a22.49 22.49 0 0 1-2.83-6.83l-.19-.83H3a.84.84 0 0 1-.84-.85v-7a.84.84 0 0 1 .84-.81h3.9l.19-.89a22.53 22.53 0 0 1 2.83-6.82l.45-.73-2.75-2.7a.85.85 0 0 1 0-1.2l4.92-4.92a.85.85 0 0 1 1.2 0l2.75 2.75.73-.45A22.44 22.44 0 0 1 24 7.09l.83-.19V3a.84.84 0 0 1 .85-.84h7a.84.84 0 0 1 .85.84v3.9l.83.19a22.66 22.66 0 0 1 6.83 2.83l.73.45 2.75-2.75a.84.84 0 0 1 1.19 0l4.92 4.92a.84.84 0 0 1 0 1.2l-2.72 2.76.45.73A22.39 22.39 0 0 1 51.34 24l.2.84h3.89a.85.85 0 0 1 .85.85z"/>
              <path d="M29.22 18.4A10.82 10.82 0 1 0 40 29.22 10.83 10.83 0 0 0 29.22 18.4zm0 19.47a8.66 8.66 0 1 1 8.65-8.65 8.67 8.67 0 0 1-8.65 8.65z"/>
            </g>
          </g>
        </svg>
      )
    case "save":
      return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.24 57.24">
          <g data-name="Layer 2">
            <path d="M49 0H6.71A6.72 6.72 0 0 0 0 6.71v43.82a6.72 6.72 0 0 0 6.71 6.71h43.82a6.72 6.72 0 0 0 6.71-6.71V8.24zM13.42 4.47h25.71v13.19H13.42zm30.41 48.3H13.42V35.1h30.41zm8.94-2.24a2.24 2.24 0 0 1-2.24 2.24H48.3V30.63H8.94v22.14H6.71a2.24 2.24 0 0 1-2.24-2.24V6.71a2.24 2.24 0 0 1 2.24-2.24h2.23v17.67H43.6V4.47h3.55l5.62 5.62z" data-name="Layer 1"/>
          </g>
        </svg>
      )
    case "ok":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.31 58.38">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M17.11 27.47a2.06 2.06 0 0 0-2.91 2.92l9.5 9.5a2 2 0 0 0 1.46.6h.1a2.3 2.3 0 0 0 1.51-.76l23.76-28.49a2.07 2.07 0 1 0-3.17-2.66L25 35.37z"/>
              <path d="M53.8 13.71a2 2 0 0 0-3.47 2.16 25 25 0 1 1-7.94-7.94 2 2 0 0 0 2.16-3.47 29.21 29.21 0 1 0 9.25 9.25z"/>
            </g>
          </g>
        </svg>
      )
    case "close":
      return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.43 58.43">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M29.21 0a29.21 29.21 0 1 0 29.22 29.21A29.27 29.27 0 0 0 29.21 0zm0 54.3A25.09 25.09 0 1 1 54.3 29.21 25.13 25.13 0 0 1 29.21 54.3z"/>
              <path d="M40.18 18a2.07 2.07 0 0 0-2.92 0l-8 8-8-8a2.06 2.06 0 0 0-2.92 2.92l8 8-8 8a2.07 2.07 0 0 0 0 2.92 2.07 2.07 0 0 0 2.92 0l8-8 8 8a2.07 2.07 0 0 0 2.92 0 2.07 2.07 0 0 0 0-2.92l-8-8 8-8a2.07 2.07 0 0 0 0-2.92z"/>
            </g>
          </g>
        </svg>
      )
    case "load":
     return(
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.1 85.69">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path d="M68 28.29v-1.52a15.57 15.57 0 0 0-18-15.39 15.61 15.61 0 0 0-29.72-1h-.65A15.63 15.63 0 0 0 4.45 29.56 9.95 9.95 0 0 0 10 47.79h55.15A10 10 0 0 0 68 28.29zM65.15 45H10a7.32 7.32 0 0 1-3.5-13.83 1.31 1.31 0 0 0 .65-1.54 13 13 0 0 1 12.43-16.74 12.85 12.85 0 0 1 1.43 0 1.33 1.33 0 0 0 1.4-.94 13 13 0 0 1 25.33 1.19 1.31 1.31 0 0 0 1.53 1h.06a12.93 12.93 0 0 1 15.91 14.7 1.31 1.31 0 0 0 1.06 1.52A7.34 7.34 0 0 1 65.15 45zM50 52.62a1.31 1.31 0 0 0-2.13-.09 14.28 14.28 0 0 1-19.51 0 1.31 1.31 0 1 0-1.75 1.91 16.9 16.9 0 0 0 23.11 0h-.1a1.31 1.31 0 0 0 .38-1.82z" className=""/>
            <path d="M55.29 60.46a1.31 1.31 0 0 0-1.52-.07 23.06 23.06 0 0 1-31.46 0 1.31 1.31 0 0 0-1.85 0 1.31 1.31 0 0 0 0 1.85 25.7 25.7 0 0 0 35.1 0 1.31 1.31 0 0 0-.27-1.78z" className="load"/>
            <path d="M62.6 68.34a1.31 1.31 0 0 0-2.13-.09h-.09a32.72 32.72 0 0 1-44.71 0 1.31 1.31 0 1 0-1.75 1.91 35.34 35.34 0 0 0 48.3 0 1.31 1.31 0 0 0 .38-1.82z" className="load1"/>
          </g>
        </g>
      </svg>
     )
    case "lang":
     return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.29 59.29">
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path d="M30.56 8.63A20.27 20.27 0 1 0 50.83 28.9 20.29 20.29 0 0 0 30.56 8.63zM47.1 27.08h-7.52c-.51-5.64-3.27-11.06-5.31-14.4a16.67 16.67 0 0 1 12.83 14.4zm-11.17 0H25.16c.59-5.35 3.57-10.65 5.4-13.45 1.82 2.8 4.78 8.09 5.36 13.45zm-9.08-14.4C24.79 16 22 21.44 21.51 27.08H14a16.67 16.67 0 0 1 12.85-14.39zM14 30.72h7.48c.52 5.64 3.28 11.06 5.33 14.4A16.67 16.67 0 0 1 14 30.72zm16.56 13.45c-1.82-2.8-4.81-8.09-5.39-13.45h10.75c-.58 5.35-3.55 10.64-5.36 13.45zm3.71.95c2-3.34 4.8-8.76 5.31-14.4h7.52a16.67 16.67 0 0 1-12.83 14.4z"/>
            <path d="M50.79 8.5A29 29 0 0 0 1.4 26a29.16 29.16 0 0 0 3.86 17.8L0 59.29 15.52 54a29 29 0 0 0 35.27-4.48 29 29 0 0 0 0-41zM48.22 47a25.55 25.55 0 0 1-31.51 3.5L16 50 5.8 53.48l3.45-10.17-.46-.73A25.39 25.39 0 1 1 48.22 47z"/>
          </g>
        </g>
      </svg>
     )
    case "usr":
     return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.29 56.46">
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path d="M29.55 31.69a15.84 15.84 0 1 0-15.87-15.87 15.87 15.87 0 0 0 15.87 15.87zm0-27.55a11.68 11.68 0 1 1-11.69 11.68A11.72 11.72 0 0 1 29.55 4.14zM39.38 34.46H19.91A19.93 19.93 0 0 0 0 54.37a2.08 2.08 0 0 0 2.09 2.09h55.1a2.08 2.08 0 0 0 2.09-2.09 19.93 19.93 0 0 0-19.9-19.91zm-35 17.82a15.75 15.75 0 0 1 15.53-13.63h19.47A15.71 15.71 0 0 1 55 52.28z"/>
          </g>
        </g>
      </svg>
     )
    case "tabcnf":
     return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.18 62.18">
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path d="M60.89 0H1.3A1.3 1.3 0 0 0 0 1.3v5.18a1.3 1.3 0 0 0 1.3 1.3h59.59a1.3 1.3 0 0 0 1.3-1.3V1.3a1.3 1.3 0 0 0-1.3-1.3zm-1.3 5.18h-57V2.59h57zM57 44a1.3 1.3 0 0 1-1.3 1.3H6.48a1.3 1.3 0 0 1-1.3-1.3V10.36H2.59V44a3.89 3.89 0 0 0 3.89 3.89H29.8v3.89h-1.3a1.3 1.3 0 0 0-1.3 1.3v7.77a1.3 1.3 0 0 0 1.3 1.3h5.18a1.3 1.3 0 0 0 1.3-1.3v-7.74a1.3 1.3 0 0 0-1.3-1.3h-1.3v-3.88H55.7A3.89 3.89 0 0 0 59.59 44V10.36H57zM32.39 59.59H29.8v-5.18h2.59z"/>
            <path d="M15.55 25.91a1.3 1.3 0 0 0-1.3 1.3v3.89h2.59v-2.6h13v5.18h-3.93a1.3 1.3 0 0 0-1.3 1.3v5.18a1.3 1.3 0 0 0 1.3 1.3h10.36a1.3 1.3 0 0 0 1.3-1.3V35a1.3 1.3 0 0 0-1.3-1.3h-3.88v-5.2h13v2.59h2.59V27.2a1.3 1.3 0 0 0-1.3-1.3H32.39v-5.17h3.89a1.3 1.3 0 0 0 1.3-1.3v-5.18a1.3 1.3 0 0 0-1.3-1.3H25.91a1.3 1.3 0 0 0-1.3 1.3v5.18a1.3 1.3 0 0 0 1.3 1.3h3.89v5.18zm11.65-7.77v-2.59H35v2.59zM35 36.27v2.59h-7.8v-2.59z"/>
          </g>
        </g>
      </svg>
     )
    case "viscnf":
     return(
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.18 62.18">
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <circle cx="34.25" cy="15.79" r="1.21"/>
            <path d="M34.25 0a27.92 27.92 0 0 0-23.57 42.91L3.5 50.1l-1.72 1.72a6.07 6.07 0 1 0 8.59 8.59l1.72-1.72 7.18-7.18A27.93 27.93 0 1 0 34.25 0zM8.65 58.69a3.64 3.64 0 1 1-5.15-5.16l.86-.86 5.15 5.15zm9.61-9.61l-7 7L6.07 51l7-7 9.47-9.47a13.43 13.43 0 0 0 5.15 5.15zm16.24-21.4a1.22 1.22 0 0 0-1.24-.29l-2.64.88v-.33a3.64 3.64 0 1 1 3.64 3.64h-.33l.88-2.64a1.21 1.21 0 0 0-.31-1.26zm-2.78 2.78l-2.41 7.23a11 11 0 0 1-4.82-4.82zm-1.59 10.18a13.36 13.36 0 0 0 9.36-25 1.21 1.21 0 1 0-1 2.23 10.93 10.93 0 0 1-6.94 20.66l1.54-4.63a6.07 6.07 0 1 0-4.81-4.9l-4.63 1.54A10.94 10.94 0 0 1 30 17.87a1.21 1.21 0 1 0-1-2.23 13.37 13.37 0 0 0-7.47 16.42l-3.73 3.73a18.23 18.23 0 1 1 8.59 8.59zm4.12 12.79A25.32 25.32 0 0 1 21 49.74l3.56-3.56A20.66 20.66 0 1 0 16 37.59l-3.56 3.56a25.5 25.5 0 1 1 21.8 12.29z"/>
          </g>
        </g>
      </svg>
     )
    case "key": 
     return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.29 60.22">
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path d="M38.93 0a20.37 20.37 0 0 0-19 27.58L.43 47A1.48 1.48 0 0 0 0 48v10.74a1.48 1.48 0 0 0 1.48 1.48h8.78a1.48 1.48 0 0 0 1-.43l3-3a1.48 1.48 0 0 0 .44-1v-3.64h3.63a1.48 1.48 0 0 0 1.48-1.48v-1.45h1.45a1.48 1.48 0 0 0 1.48-1.48v-3.2h3.19a1.48 1.48 0 0 0 1-.43l4.72-4.72A20.36 20.36 0 1 0 38.93 0zm0 37.74a17.26 17.26 0 0 1-7-1.46 1.48 1.48 0 0 0-1.63.3l-5 5h-4.03a1.48 1.48 0 0 0-1.48 1.48v3.19h-1.46a1.48 1.48 0 0 0-1.48 1.48v1.45h-3.63a1.48 1.48 0 0 0-1.48 1.48v4.5l-2.09 2.1H3v-2.1L21.1 37a1.34 1.34 0 0 0-1.89-1.89L3 51.38V48.7L22.69 29a1.48 1.48 0 0 0 .3-1.63 17.39 17.39 0 1 1 15.94 10.37z"/>
            <path d="M45.13 8.6a5.56 5.56 0 1 0 5.56 5.56 5.56 5.56 0 0 0-5.56-5.56zm0 8.15a2.59 2.59 0 1 1 2.59-2.59 2.59 2.59 0 0 1-2.59 2.59z"/>
          </g>
        </g>
      </svg>
     )
    case "trash":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.92 58.38">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M50.3 8.4H38.16v-2A6.43 6.43 0 0 0 31.73 0H20.19a6.43 6.43 0 0 0-6.42 6.42v2H1.62a1.62 1.62 0 1 0 0 3.24h2.93v38.05a8.68 8.68 0 0 0 8.67 8.67h25.49a8.68 8.68 0 0 0 8.67-8.67V11.64h2.92a1.62 1.62 0 0 0 0-3.24zM17 6.42a3.19 3.19 0 0 1 3.18-3.18h11.55a3.19 3.19 0 0 1 3.18 3.18v2H17zm27.13 43.29a5.43 5.43 0 0 1-5.43 5.43H13.21a5.43 5.43 0 0 1-5.42-5.43V11.64h36.35v38.07zm0 0"/>
              <path d="M26 49.33a1.61 1.61 0 0 0 1.62-1.62V19.07a1.62 1.62 0 1 0-3.24 0V47.7A1.62 1.62 0 0 0 26 49.33zm0 0M15.39 47.54A1.61 1.61 0 0 0 17 45.92V20.85a1.62 1.62 0 1 0-3.24 0v25.07a1.62 1.62 0 0 0 1.62 1.62zm0 0M36.54 47.54a1.61 1.61 0 0 0 1.62-1.62V20.85a1.62 1.62 0 1 0-3.24 0v25.07a1.61 1.61 0 0 0 1.62 1.62zm0 0"/>
            </g>
          </g>
        </svg>
      )
    case "view":
      return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.9 41.23">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M76.11 18.7C75.38 17.9 57.28 0 38.45 0S1.52 17.9.79 18.7a2.71 2.71 0 0 0 0 3.83c.79.79 18.89 18.7 37.66 18.7s36.93-17.91 37.66-18.7a2.71 2.71 0 0 0 0-3.83zm-37.66 17C25.3 35.74 11.76 25 6.67 20.55c5.09-4.5 18.63-15.2 31.78-15.2s26.69 10.7 31.78 15.19C65.14 25 51.6 35.74 38.45 35.74z"/>
              <path d="M28.74 20.55a9.78 9.78 0 1 0 9.78-9.78 9.8 9.8 0 0 0-9.78 9.78zm9.71-4.36a4.44 4.44 0 0 1 4.36 4.36 4.36 4.36 0 1 1-4.36-4.36z"/>
            </g>
          </g>
        </svg>
      )
    case "edit":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.19 59.07">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M58 54.88H2.15A2.1 2.1 0 0 0 0 57a2.14 2.14 0 0 0 2.1 2.1h56a2.1 2.1 0 0 0 2.09-2.1A2.15 2.15 0 0 0 58 54.88zm0 0M0 36.33v10a2.16 2.16 0 0 0 .61 1.53 2 2 0 0 0 1.48.61H12a2 2 0 0 0 1.48-.61l34.25-34.32a2.16 2.16 0 0 0 0-3L37.92.61a2.16 2.16 0 0 0-3 0l-6.85 6.9L.66 34.85A2.28 2.28 0 0 0 0 36.33zM36.43 5.11l6.9 6.9-3.88 3.88L32.55 9zM4.29 37.25L29.53 12l6.9 6.9-25.24 25.2-6.95.05zm0 0"/>
            </g>
          </g>
        </svg>
      )
    case "download":
      return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.92 75.92">
          <defs>
            <clipPath id="a" transform="translate(0 -.12)">
              <path fill="none" d="M0 0h81.88v76.25H0z"/>
            </clipPath>
          </defs>
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <g clipPath="url(#a)">
                <path d="M79.57 37.01a2.34 2.34 0 0 0-2.35 2.35v21.35a10.53 10.53 0 0 1-10.51 10.52h-51.5A10.53 10.53 0 0 1 4.69 60.71v-21.7a2.35 2.35 0 1 0-4.69 0v21.7a15.23 15.23 0 0 0 15.21 15.17h51.5a15.23 15.23 0 0 0 15.21-15.17V39.36a2.35 2.35 0 0 0-2.35-2.35zm0 0"/>
              </g>
              <path d="M39.31 57.28a2.37 2.37 0 0 0 1.65.7 2.29 2.29 0 0 0 1.65-.7l14.92-14.91a2.35 2.35 0 0 0-3.32-3.32l-10.9 10.92V2.35a2.35 2.35 0 1 0-4.69 0v47.62L27.69 39.05a2.35 2.35 0 0 0-3.32 3.32zm0 0"/>
            </g>
          </g>
        </svg>
      )
    case "logout":
      return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.3 57.51">
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path d="M25.68 54.21h-15a7.39 7.39 0 0 1-7.38-7.38V10.68a7.39 7.39 0 0 1 7.38-7.38h15.24a1.65 1.65 0 0 0 0-3.3H10.68A10.69 10.69 0 0 0 0 10.68v36.15a10.69 10.69 0 0 0 10.68 10.68h15a1.65 1.65 0 0 0 0-3.3zm0 0"/>
              <path d="M52.82 27.59L42.35 17.12A1.65 1.65 0 1 0 40 19.45l7.66 7.66H14.25a1.65 1.65 0 1 0 0 3.29h33.43L40 38.08a1.65 1.65 0 0 0 1.16 2.82 1.61 1.61 0 0 0 1.16-.49l10.49-10.47a1.65 1.65 0 0 0 0-2.34zm0 0"/>
            </g>
          </g>
        </svg>
      )
    default:
      break;
  }
}

export default Icons;


// WEBPACK FOOTER //
// ./src/Containers/Icons.js